export default "__VITE_ASSET__8f113fbf__"